import React, { useState, useEffect } from 'react';
import { stacksApi, stacksExplorer, stacksExplorerParam, clientNetwork, profileContract } from '../../lib/constants';
import { useNavigate } from 'react-router-dom';
import { BiGift } from "react-icons/bi";
import { BsHeart, BsHeartbreak, BsInfoCircle, BsSearch, BsArrowUpCircle, BsArrowDownCircle } from 'react-icons/bs';
import { PiChats, PiChatText } from "react-icons/pi";
import axios from 'axios';
import './style.scss'
import { CircularProgress } from '@mui/material';
import { getUserData, authenticatedUserAddress } from '../../services/auth';
import Alert from '@mui/material/Alert';

function History({ userSettings }) {
  const [transactions, setTransactions] = useState([]);
  const [transactionsTx, setTransactionsTx] = useState([]);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadMore, setLoadMore] = useState(true);

  let authenticatedUser = authenticatedUserAddress({ network: clientNetwork });
  console.log("p1 automagic networking: " + authenticatedUser)

  const navigate = useNavigate();
  function navTo(to_txId, where_to) {
    if (where_to === "search") {
      navigate(`/${to_txId}`);
    } else {
      window.open(`${userSettings?.stacksExplorer || stacksExplorer}/txid/${to_txId}${stacksExplorerParam}`, "_blank");
    }
  }

  // async function fetchTx() {
  //   function removeDuplicates(arr) {
  //     const uniqueArray = [...transactionsTx];
  //     for (const item of arr) {
  //       if (!uniqueArray.includes(item)) {
  //         uniqueArray.push(item);
  //       } else {
  //         console.log('duplicate found', item);
  //       }
  //     }
  //     return uniqueArray;
  //   };
  //   console.log('firing at', offset);
  //   setLoading(true);
  //   const { data: { events } } = await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/extended/v1/tx/events?address=${authenticatedUser}&offset=${offset}`);
  //   if (events.length === 0) {
  //     setLoadMore(false);
  //     setLoading(false);
  //     return
  //   }

  //   const tx = events.map(({ tx_id }) => tx_id);
  //   const filteredTx = removeDuplicates(tx);
  //   // console.log('filtered duplicates', tx, filteredTx);

  //   for (let i = 0; i < filteredTx.length; i++) {
  //     const { data } = await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/extended/v1/tx/${filteredTx[i]}`);
  //     const { contract_call, contract_call: { contract_id } = {} } = data || {};
  //     if (contract_call && contract_id.split('.')[1] === profileContract && !transactionsTx.includes(filteredTx[i])) {
  //       setTransactions(transactions => [...transactions, data])
  //       setTransactionsTx(transactionsTx => [...transactionsTx, filteredTx[i]])
  //       setLoading(false);
  //     }
  //   }
  //   const newOffset = offset + 20;
  //   setOffset(newOffset);
  // }

  // Define a debounced version of handleScroll
  // const debouncedHandleScroll = debounce(handleScroll, 300); // Adjust the debounce delay as needed

  async function fetchTx() {
    setLoading(true);
    const { data: { events } } = await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/extended/v1/tx/events?address=${authenticatedUser}&offset=${offset}`);
    if (events.length === 0) {
      setLoadMore(false);
      setLoading(false);
      return
    }

    const existingTx = transactions.map(({ tx_id }) => tx_id);
    let results = events.filter(({ tx_id }) => !existingTx.includes(tx_id));
    results = await Promise.all(results.map(async ({ tx_id }) => {
      const { data } = await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/extended/v1/tx/${tx_id}`);
      const { contract_call, contract_call: { contract_id } = {} } = data || {};
      if (contract_call && contract_id?.split?.('.')[1] === profileContract && !existingTx.includes(tx_id)) {
        return data;
      }
    }));
    results = results.filter((res) => res !== undefined);
    results = Array.from(new Set(results.map(JSON.stringify)), JSON.parse);
    setTransactions(prev => [...prev, ...results]);
    const newOffset = offset + 20;
    setOffset(newOffset);
    setLoading(false);
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollOffset = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.offsetHeight;
      if (scrollOffset >= pageHeight) {
        setLoadMore(false);
        // Set a timeout for delayed execution
        setTimeout(() => {
          console.log('fired at', offset);
          fetchTx();
        }, 10000); // Adjust the delay time (in milliseconds) as needed
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [transactions, offset, transactionsTx, loading, offset]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (transactions.length < 1) {
        fetchTx();
      }
    }, 5000);

    return () => clearInterval(intervalId);
  }, [transactions, offset, transactionsTx]);

  console.log(transactions);
  return (
    <div className="history-container" >
      <Alert severity="info" color="warning">
        View Your History
      </Alert>
      <ul className="history-items">
        {transactions.length > 0 &&
          transactions.map(({ tx_id, sender_address, contract_call: { function_name, function_args } }, i) => {
            const shortenedTx = `${tx_id.substring(0, 5)}...${tx_id.substring(tx_id.length - 5, tx_id.length)}`;
            const switching = {
              "favorable-message": tx_id, "unfavorable-message": tx_id, "send-message": tx_id,
              "like-message": String(function_args[1].repr.split('u')[1]).replace(/^"|"$/g, ''),
              "dislike-message": String(function_args[1].repr.split('u')[1]).replace(/^"|"$/g, ''),
              "gift-message": String(function_args[2].repr.split('u')[1]).replace(/^"|"$/g, '')
            }
            const explorerTx = tx_id;
            const inAppSearchTx = switching[function_name];

            const functionIcons = { "gift-message": <BiGift />, "like-message": <BsHeart />, "dislike-message": <BsHeartbreak />, "send-message": <PiChatText />, "favorable-reply-message": <PiChats />, "unfavorable-reply-message": <PiChats /> };
            return (
              <li className="history-item" key={i}>
                {/* Render for gift-message */}
                <p id="history-summary">
                  <BsSearch onClick={() => navTo(inAppSearchTx, ["favorable-message", "unfavorable-message", "send-message"][function_name] ? '' : 'search')} />
                  {sender_address === authenticatedUser ? <BsArrowUpCircle /> : <BsArrowDownCircle />}
                  {functionIcons[function_name]}
                  {shortenedTx}
                  <BsInfoCircle onClick={() => navTo(explorerTx, 'explorer')} id="explorer-history-icon" />
                </p>
              </li>
            )
          })
        }
      </ul>
      {console.log()}
      {loading ? <CircularProgress size={25} /> : null}
      {(!loading && loadMore && transactions.length > 0) ? <button className={'loadmore-button'} disabled={loading} onClick={() => fetchTx()}>Load More</button> : null}
    </div>
  )
}

export default History;